/**
 * @generated SignedSource<<a2c852af5b9ae2ffc0c45824180e4cbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateEditFlightPriceHistory_flight$data = {
  readonly history: {
    readonly pageInfo: {
      readonly total: number;
    };
    readonly " $fragmentSpreads": FragmentRefs<"FlightPriceHistoryTable_history">;
  };
  readonly " $fragmentType": "PackageDateEditFlightPriceHistory_flight";
};
export type PackageDateEditFlightPriceHistory_flight$key = {
  readonly " $data"?: PackageDateEditFlightPriceHistory_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateEditFlightPriceHistory_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateEditFlightPriceHistory_flight",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10
        },
        {
          "kind": "Literal",
          "name": "onlyPriceChanged",
          "value": true
        }
      ],
      "concreteType": "FlightPriceConnection",
      "kind": "LinkedField",
      "name": "history",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FlightPriceHistoryTable_history"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "total",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "history(first:10,onlyPriceChanged:true)"
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "7a603e40947d7411207e6c2f524d2b06";

export default node;
